import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import config from "util/ApiforContext";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";

import TosOrderSentTableFilter from "../Filters/TosOrderSentTableFilter";

import moment from "moment";

import { Table, Empty, Col, Row, Button,message, Modal } from "antd";
import {
  BarsOutlined,
  FilePdfOutlined,
  InfoCircleOutlined,
  SendOutlined,
  IdcardOutlined
} from "@ant-design/icons";

const TosSentOrderList = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [selectedRows, setSelectedRows] = useState({
    keys: [],
    data: [],
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "&$filter=DirectiveStatusId ne 1 and DirectiveStatusId ne 7",
  });
  const [isTosAuthorize, setIsTosAuthorize] = useState(false);

  const history = useHistory();

  const [showApprovedUserModal, setShowApprovedUSerModal] = useState(false);

  const [approvedUsers, setApprovedUsers] = useState([]);


  useEffect(() => getTableData(), [tableDataQueryOptions]);

  useEffect(() => {
    RequestHandler.get("/TenantUser/IsTosAuthorize").then((response) => {
       setIsTosAuthorize(response);
    });
  }, [])

  const getTableData = () => {
    const { skip, take, filter } = tableDataQueryOptions;

    setTableData({
      ...tableData,
      loading: true,
    });

     RequestHandler.get(
       `/Directive?$count=true${filter}&$skip=${skip}&$top=${take}`
     ).then((response) => {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
     });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };
  const onClickCreateOrder = () => {

  };
  const onClickCreatePdf = (id) => {
    const hideMessage = message.loading("Pdf indiriliyor...", 0);
    RequestHandler.get(
      `/Directive/CreatePdf?id=${id}`
    ).then((response) => {
      hideMessage();
      window.open(
        config.apiUrl.replace("/api","")+"/content/sourcepdf/tospdf/downloadpdfs/"+response,
        '_blank' // <- This is what makes it open in a new window.
      );
    });
  };
  const onClickRetryDirective = (selectedRows) => {
    RequestHandler.post(
      "/Directive/RetryDirective",
      {
        directiveIds: selectedRows
      },
      true
    ).then((res) => {
      window.location.reload();
    });
    setTimeout(() => {
    }, 500);
  };
  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "&$filter=DirectiveStatusId ne 1 and DirectiveStatusId ne 7",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const onTableSelectChange = (selectedKeys, selectedRecords) => {
    setSelectedRows({
      keys: selectedKeys,
      data: selectedRecords,
    });
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Talimat Numarası",
      dataIndex: "directiveNumber",
    },
    {
      title: "Ödeme Tarihi",
      dataIndex: "paymentDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Talimat Durumu",
      dataIndex: "directiveStatus",
    },
    {
      title: "Adet",
      dataIndex: "quantity",
    },
    {
      title: "Tutar",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
      align:"right"
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode"
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },
    {
      title:"Hazırlayan Kişi",
      dataIndex: "creator",
    },
    {
      title: "Onaylayan Kişiler",
      dataIndex: "approvedUsers",
      align: "center",
      render: (data,row) => (
        <a style={{ fontSize: "130%" }}>
          <IdcardOutlined onClick={() => showApprovedUsers(data) } />
        </a>
      )
    },
    {
      title: "Pdf İndir",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a onClick={() => {onClickCreatePdf(row.id)}} download >
          <FilePdfOutlined style={{ color: "red", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Detay",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a style={{ fontSize: "130%" }}>
          <InfoCircleOutlined
            onClick={() => history.push(`tos-sent-payment/${row.id}/false`)}
          />
        </a>
      ),
    },
  ];


  const approvedUserColumns = [
    {
      title: "İsim Soyisim",
      dataIndex: "fullName",
    },
    {
      title: "Onaylama Tarihi",
      dataIndex: "approvedDateTime",
    }
  ];

  const showApprovedUsers = (users) => {
    setApprovedUsers(users);
    setShowApprovedUSerModal(true);
  }

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> GÖNDERİLMİŞ TALİMATLAR
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
        {selectedRows.keys.length > 0 && (
            <Button onClick={() => {onClickRetryDirective(selectedRows.keys)}} style={{ marginBottom: 0 }} disabled={!isTosAuthorize}>
              <SendOutlined /> Talimatı Tekrarla
            </Button>
          )}
          {/* {selectedRows.keys.length > 0 && (
            <Button onClick={onClickCreateOrder} style={{ marginBottom: 0 }}>
              <SendOutlined /> Bankaya Gönder
            </Button>
          )} */}
        </Col>
      </Row>

      <TosOrderSentTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            rowSelection={{
              selectedRowKeys: selectedRows.keys,
              onChange: onTableSelectChange,
              getCheckboxProps: () => ({
                disabled: !isTosAuthorize
              })
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              showSizeChanger:true,
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Modal visible={showApprovedUserModal} footer={false} onCancel={() => { setShowApprovedUSerModal(false) }} >

        <Table
          columns={approvedUserColumns}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Veri Yok"
              />
            ),
          }}
          style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
          rowKey="approvedDateTime"
          dataSource={approvedUsers}
          loading={tableData.loading}
          size="small"
        />
      </Modal>
    </>
  );
};

export default TosSentOrderList;
